<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form ref="form">
          <v-container class="py-0">
            <v-row>
              <v-toolbar-title>{{ $t('keywords.register') }}</v-toolbar-title>
            </v-row>
            <v-row>
              <v-text-field
                :rules="usernameRules(objEditar.userKey.username)"
                name="username"
                :label="$t('keywords.username')"
                v-model="objEditar.userKey.username"
                :disabled="isUpdating"
              />
            </v-row>
            <v-row v-if="!isUpdating">
              <v-text-field
                v-model="objEditar.password"
                :label="$t('keywords.password')"
                :hint="$t('user.password_rules')" persistent-hint
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                append-outer-icon="mdi-key-plus"
                @click:append="showPassword = !showPassword"
                @click:append-outer="objEditar.password = randomPassword(12, passwordComplexityRules)"
                :rules="passwordComplexityRules(objEditar.password)"
              />
            </v-row>
            <v-row>
              <PermissionSelector v-model="objEditar" :required="true" />
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn color="success" class="mr-0" @click="saveItem">{{ $t('button.save') }}</v-btn>
        <v-btn color="blue darken-1" text @click="close">{{ $t('button.cancel') }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/UserService'
import LocalStorageService from '../../services/LocalStorageService'
import { usernameRules, passwordComplexityRules } from '../../utils/rules'
import PermissionSelector from './components/PermissionSelector.vue'
import randomPassword from '../../utils/RandomPassword'

export default {
  name: 'credentialForm',

  props: {
    identifier: String
  },

  components: { PermissionSelector },

  data: () => ({
    usernameRules,
    passwordComplexityRules,
    randomPassword,
    showPassword: false,
    objEditar: {
      userKey: {
        username: '',
        clientPrefix: LocalStorageService.getClientPrefix()
      },
      password: '',
      permissions: null
    },
    isUpdating: false
  }),

  mounted () { this.loadDB() },

  methods: {
    loadDB () {
      const clientPrefix = LocalStorageService.getClientPrefix()
      this.isUpdating = !!this.identifier
      if (this.identifier) {
        Servico.findById(clientPrefix, this.identifier)
          .then(response => {
            this.isUpdating = true
            this.objEditar = response.data
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
      }
    },
    saveItem () {
      if (this.$refs.form.validate()) {
        if (this.isUpdating) this.updateItem()
        else this.createItem()
      } else {
        this.$message.error(this.$t('warnings.validation.fill_required_fields'))
      }
    },
    createItem () {
      Servico.usernameExists(this.objEditar.userKey.username).then(response => {
        if (response.data === false) {
          Servico.insert(this.objEditar)
            .then(() => this.$emit('editItem', true, null))
            .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
        } else {
          this.$message.error(this.$t('warnings.username_unavailable'))
        }
      })
    },
    updateItem () {
      Servico.update(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },
    close () {
      this.$emit('editItem', true, null)
    }
  }

}
</script>
